import { Injectable } from '@angular/core';



interface TranslateType {
  [lang: string]: TranslateObject;
}

interface TranslateObject {
  [key: string]: TranslateLang;
}

interface TranslateLang {
  [key: string]: string;
}

@Injectable({
  providedIn: 'root'
})

export class TranslateService {
  constructor() { }

  private translateObj: TranslateType = {
    "common": {
      'en': {
        "homepage": "Homepage",
        'credit_amount': 'Loan Amount',
        'credit_maturity': 'Maturity',
        'credit_rate': 'Interest Rate',
        'credit_cost': 'Loan Allocation Fee',
        'credit_plan': 'Interest Table and Repayment Schedule',
        'credit_monthly_payment': 'Monthly Installment Amount',
        'credit_deposit_amount': 'Amount To Be Transferred to Your Account',
        'credit_total_amount': 'Total Amount You Will Pay',
        'credit_term': 'Loan Maturity Period (Months)',
        'credit_installmentcount': 'Number of Installments',
        'credit_fee': 'Allocation Fee',
        'credit_late_interest_rate': 'Overdue Interest Rate',
        'credit_annual_effective_rate': 'Annual Effective Rate',
        'credit_annual_effective_rate_note': 'Loan allocation fee includes BITT (Banking and Insurance Transactions Tax) of 15%, and all interest, fees, BITT and RUSF, collected for the loan, are included in the calculation of the Effective Annual Interest Rate. Insurance is not included.',//Yıllık
        "credit_contract_effective_rate_note": "Loan allocation fee includes BITT (Banking and Insurance Transactions Tax) of 15%, and all interest, fees, BITT and RUSF, collected for the loan, are included in the calculation of the Effective Annual Interest Rate. Insurance is not included",//Akdi
        "credit_installment_and_mortgage_loan_effective_rate_note": "Loan allocation fee includes BITT (Banking and Insurance Transactions Tax) of 15%, and all interest, fees, BITT and RUSF, collected for the loan, are included in the calculation of the Effective Annual Interest Rate. Insurance is not included",//taksit kredisi ve tasit kredisi özel
        'credit_contract_interest_rate': 'Contractual Rate of Interest',
        'credit_sample_plan': 'Sample Payment Plan',
        'credit_installment': 'Installment',
        'credit_installment_order': 'Installment Order',
        'credit_installment_date': 'Installment Date',
        'credit_interest_share': 'Interest Share',
        "credit_installment_amount": "Installment Amount",
        "credit_principal_share": "Principal Share",
        "credit_apply": "Apply Now",
        "search_placeholder": "Search",
        "online_banking": "Online Banking",
        "personal": "Personal",
        "bussiness": "Bussiness",
        "city": "City",
        "district": "District",
        "sector": "Sector",
        "brand": "Brand",
        "currency": "Currency",
        "amount": "Amount",
        "net_interest_income": "Net Return Amount",
        "start_to_earn": "Start to Earn",
        "apply_now": "Apply Now",
        'k_rusf': 'RUSF (Resource Utilization Support Fund)',
        "all_years": "All Years",
        "choose_city": "Choose City",
        "choose_county": "Choose County",
        "branch_name": "Branch Name",
        "address": "Address",
        "phone_fax": "Phone / Fax"
      },
      "tr": {
        "homepage": "Ana Sayfa",
        "credit_amount": "Kredi Miktarı",
        "credit_maturity": "Vade",
        "credit_rate": "Faiz Oranı",
        "credit_cost": "Kredi Tahsis Ücreti",
        "credit_plan": "Faiz Tablosu ve Ödeme Planı",
        "credit_monthly_payment": "Aylık Taksit Tutarı",
        "credit_deposit_amount": "Hesabınıza Yatacak Tutar",
        "credit_total_amount": "Toplam Ödeyeceğiniz Tutar",
        "credit_term": "Kredi Vadesi (Ay)",
        "credit_installmentcount": "Taksit Sayısı",
        "credit_fee": "Tahsis Ücreti",
        "credit_late_interest_rate": "Gecikme Faiz Oranı",
        "credit_annual_interest_rate": "Yıllık Efektik Oranı",
        'credit_annual_effective_rate': 'Efektif Yıllık Faiz Oranı',
        "credit_annual_effective_rate_note": "Kredi tahsis ücreti %15 BSMV içermekte olup, Efektif Yıllık Faiz oranı hesaplamasına kredi için kredi için tahsil edilen tüm faiz, ücret, BSMV ve KKDF dahil edilmiştir. Sigorta dahil edilmemiştir.",//Yıllık
        "credit_contract_effective_rate_note": "Faiz oranı kredi notuna göre değişkenlik gösterebilir. Kredi kullandırımından önce kredi notuna uygun olan faiz oranı onayına sunulur. Aktif Bank kampanya şartlarını ve faiz oranlarını değiştirme hakkını saklı tutar.",//Akdi
        "credit_installment_and_mortgage_loan_effective_rate_note": "Kredi tahsis ücreti %15 BSMV içermekte olup, Efektif Yıllık Faiz Oranı hesaplamasına kredi için tahsil edilen tüm faiz, ücret, BSMV ve KKDF dahil edilmiştir. Sigorta dahil edilmemiştir.",//taksit kredisi ve tasit kredisi özel
        "credit_contract_interest_rate": "Akdi Faiz Oranı",
        "credit_sample_plan": "Örnek Ödeme Planı",
        "credit_installment": "Taksit",
        "credit_installment_order": "Taksit Sıra No",
        "credit_installment_date": "Taksit Tarihi",
        "credit_interest_share": "Faiz Payı",
        "credit_installment_amount": "Taksit Tutarı",
        "credit_principal_share": "Ana Para Payı",
        "credit_apply": "Hemen Başvur",
        "search_placeholder": "Ara",
        "online_banking": "İnternet Şubesi",
        "personal": "Bireysel",
        "bussiness": "Kurumsal",
        "city": "Şehir",
        "district": "İlçe",
        "sector": "Sektör",
        "brand": "Marka",
        "currency": "Para Birimi",
        "amount": "Yatıracağınız Tutar",
        "net_interest_income": "Net Dönüş Tutarı",
        "start_to_earn": "Kazanmaya Başlayın",
        "apply_now": "Hemen Başvurun",
        'k_rusf': 'KKDF',
        "all_years": "Tüm Yıllar",
        "choose_city": "Şehir Seç",
        "choose_county": "İlçe Seç",
        "branch_name": "Şube Adı",
        "address": "Adres",
        "phone_fax": "Telefon / Fax"
      },
    },
    "contact": {
      'tr': {
        "iletisim-merkezi": "İletişim Merkezi",
        "email": "E-Posta",
        "phone": "Telefon",
        "haritada-goster": "Haritada Göster",
        "yer-saglayici": "Yer Sağlayıcı",
        "kayitli-eposta": "Kayıtlı E-Posta",
        "sorumlu-kisi": "Sorumlu Kişi",
        "sorumlu-kisi-value": "Alternatif Satış Kanalları ve İletişim Merkezi",
        "ticaret-unvani": "Ticaret Ünvanı",
        "ticaret-sicil": "Ticaret Sicil No",
        "yonetmelik-bilgi": "26.08.2015 tarihli “Elektronik Ticarette Hizmet Sağlayıcı ve Aracı Hizmet Sağlayıcılar Hakkında Yönetmelik” kapsamında bilgi verme yükümlülüğümüz nedeniyle yukarıda iletişim bilgilerimizi bulabilirsiniz. Görüş, öneri ve şikayetlerinizi İletişim Merkezi’mizi arayarak ya da iletişim formunu kullanarak 7/24 iletebilirsiniz.",
        "aktifbank_headquarters": "Aktif Bank Genel Müdürlük",
        "address_1": "Esentepe Mahallesi Kore Şehitleri Caddesi No: 8/1 Şişli / İSTANBUL",
        "contact_form": "İletişim Formu"
      },
      'en': {
        "iletisim-merkezi": "Communication Center",
        "email": "Email",
        "phone": "Phone",
        "haritada-goster": "View in Maps",
        "yer-saglayici": "Host",
        "kayitli-eposta": "E-Mail",
        "sorumlu-kisi": "Unit in Charge",
        "sorumlu-kisi-value": "Alternative Sales Channels and Contact Center",
        "ticaret-unvani": "Trade Name",
        "ticaret-sicil": "Trade Registry Number",
        "yonetmelik-bilgi": "You can find our contact information above due to our obligation to provide information within the scope of the “Regulation on Service Providers and Intermediary Service Providers in Electronic Commerce” dated 26.08.2015. You can send your opinions, suggestions and complaints 24/7 by calling our Contact Center or using the contact form.",
        "aktifbank_headquarters": "Aktif Bank Headquarters",
        "address_1": "Esentepe District, Kore Şehitleri Street No: 8/1 Şişli İstanbul",
        "contact_form": "Contact Form"
      },
    },
    "employee": {
      'tr': {
        "employee_profile": "Çalışan Profilimiz",
        "gender_distribution": "Cinsiyet Dağılımı",
        "female": "Kadın",
        "male": "Erkek",
        "education_status": "Eğitim Durumu",
        "doctorate_and_postgraduate": "Doktora ve Yüksek Lisans",
        "undergraduate": "Lisans",
        "other": "Diğer"
      },
      'en': {
        "employee_profile": "Employee Profile",
        "gender_distribution": "Gender Distribution",
        "female": "Female",
        "male": "Male",
        "education_status": "Educational Background",
        "doctorate_and_postgraduate": "PhD and Master's",
        "undergraduate": "Bachelor's Degree",
        "other": "Other"
      }
    }
  }

  public translate(name: string, lang: string, key: string): string {
    return this.translateObj[name][lang][key];
  }
}
